import * as types from "../types/actionTypes";
import objectAssign from "object-assign";
import fetch from "node-fetch";
import utils from "./../../universal/utils";
import * as cookieStorage from "./common/cookieStorage";
import { getMotoTiresQueryKey, getMotoTirePairsQueryKey } from "../utils/motoTiresQueryKey";
import { prepareListingProducts } from "../../components/list/tireListModel";

const cStorage = cookieStorage.getCookieStorage();

// Matches what /list/moto/:w/:p/:r shows by default: single tires after the
// listing's visibility rules, or every product when the size has no singles.
export function countSizePageResults(result) {
  const prepared = prepareListingProducts(Array.isArray(result) ? result : []);
  const singles = prepared.filter((product) => !product.set).length;
  return singles > 0 ? singles : prepared.length;
}

const basePath = utils.getEdgeBasePath();

export function getPopularSizes() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/popular/sizes?limit=8`).then(function (
      apiResult
    ) {
      return apiResult.json().then(function (data) {
        return dispatch({
          type: types.LOAD_POPULAR_SIZES,
          metrics: data,
        });
      });
    });
  };
}

export function getPopularTireSets() {
  return function (dispatch) {
    return fetch(`${basePath}/api/v1/sizes/popular-sets`)
      .then((apiResult) => apiResult.json())
      .then((data) => {
        if (!data || !Array.isArray(data.result)) return;
        dispatch({
          type: types.LOAD_POPULAR_TIRE_SETS,
          popularTireSets: data.result,
        });
      })
      .catch((err) => err);
  };
}

export function setCheckoutActiveStep(stepIndex) {
  return {
    type: types.CHECKOUT_ACTIVE_STEP,
    stepIndex,
  };
}

export function resetCartConditions() {
  return {
    type: types.CHECKOUT_RESET_CART_CONDITIONS,
  };
}

export function setListPending(aBool) {
  return {
    type: types.LOADING,
    loading: aBool,
  };
}

export function getTopSellers() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/top/sellers`).then(function (apiResult) {
      return apiResult.json().then(function ({ products }) {
        return dispatch({
          type: types.LOAD_TOP_SELLERS,
          products,
        });
      });
    });
  };
}

export function getLimitedTimeOffers() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/limited-time-offers/active`).then(function (apiResult) {
      return apiResult.json().then(function (data) {
        if (data.success && data.offers) {
          // Store full offers with expiration dates
          return dispatch({
            type: types.LOAD_LIMITED_TIME_OFFERS,
            limitedTimeOffers: data.offers,
          });
        }
        return dispatch({
          type: types.LOAD_LIMITED_TIME_OFFERS,
          limitedTimeOffers: [],
        });
      });
    }).catch(function (error) {
      console.error('Error loading limited time offers:', error);
      return dispatch({
        type: types.LOAD_LIMITED_TIME_OFFERS,
        limitedTimeOffers: [],
      });
    });
  };
}

export function getHomepagePromo() {
  return function (dispatch) {
    return fetch(`${basePath}/api/v1/homepage-promo`)
      .then(function (apiResult) {
        return apiResult.json().then(function (data) {
          return dispatch({
            type: types.LOAD_HOMEPAGE_PROMO,
            homepagePromo: {
              salePercent: data.salePercent || 0,
              display: data.display || 'wizard',
              promos: data.promos || [],
              loaded: true,
            },
          });
        });
      })
      .catch(function (error) {
        console.error('Error loading homepage promo:', error);
        return dispatch({
          type: types.LOAD_HOMEPAGE_PROMO,
          homepagePromo: { salePercent: 0, display: 'wizard', promos: [], loaded: true },
        });
      });
  };
}

export function loadTireDimensionsWidths() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/sizes/widths/for/MO`).then(function (apiResult) {
      return apiResult.json().then(function (widths) {
        return dispatch({
          type: types.LOAD_TIRE_DIMS_WIDTHS,
          widths,
        });
      });
    });
  };
}

export function getPaymentDetails({ orderId, token }) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/pdata/${orderId}/${token}`).then(function (
      apiResult
    ) {
      return apiResult.json().then(function (data) {
        return dispatch({
          type: types.ADMIN_LOAD_ORDER_PAYMENT,
          orderId,
          cData: data.cData,
        });
      });
    });
  };
}

export function updateStatusInflight() {
  return {
    type: types.ADMIN_STATUS_INFLIGHT,
  };
}

export function getOrders() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/orders`, {
      headers: utils.getAdminAuthHeaders(),
    }).then(
      function (apiResult) {
        return apiResult.json().then(function ({ orders, products }) {
          return dispatch({
            type: types.ADMIN_LOAD_ORDERS,
            orders,
            products,
          });
        });
      }
    );
  };
}

export function collectMetric(metadata) {
  const stats = cStorage.getObject("stats");
  const { visitorId } = stats;

  return function (dispatch) {
    fetch(`${basePath}/collector/collect/${visitorId}`, {
      method: "POST",
      body: JSON.stringify(metadata),
      headers: { "Content-Type": "application/json" },
    }).then(function (apiResult) {
      return apiResult.json().then(function (json) {
        if (json.ok) {
          console.log("metric reported correctly");
        }
      });
    });
  };
}

export function reportLikeEventForProduct(productId) {
  const stats = cStorage.getObject("stats");
  const { visitorId } = stats;

  return function (dispatch) {
    fetch(`${basePath}/collector/like/product/${productId}/${visitorId}`).then(
      function (apiResult) {
        return apiResult.json().then(function () {
          return dispatch({
            type: types.PRODUCT_LIKE,
            productId,
            visitorId,
          });
        });
      }
    );
  };
}

export function reportLikeEventForShop(shopId) {
  const stats = cStorage.getObject("stats");
  const { visitorId } = stats;

  return function (dispatch) {
    fetch(`${basePath}/collector/like/shop/${shopId}/${visitorId}`).then(
      function (apiResult) {
        return apiResult.json().then(function () {
          return dispatch({
            type: types.SHOP_LIKE,
            shopId,
            visitorId,
          });
        });
      }
    );
  };
}

export function getTrackingVisitorId() {
  const statsFromCookieStorage = cStorage.getObject("stats");

  if (statsFromCookieStorage !== null) {
    // User has an active visitorId, don't ask for one.
    return function (dispatch) {
      dispatch({
        type: types.STATS_UPDATED,
        stats: statsFromCookieStorage,
      });
    };
  }

  return function (dispatch) {
    fetch(`${basePath}/collector/visitor/id`).then(function (apiResult) {
      return apiResult.json().then(function (result) {
        const stats = {
          data: {
            likes: {
              products: [],
              shops: [],
            },
          },
          visitorId: result.visitorId,
        };

        dispatch({
          type: types.STATS_UPDATED,
          stats,
        });

        cStorage.setObject("stats", stats);
      });
    });
  };
}

export function submitBestOffer(offer) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/best-offers`, {
      body: JSON.stringify(offer),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(({ data }) => {
        dispatch({
          type: types.BEST_OFFER_SENT,
          data,
        });
      });
    });
  };
}

export function submitTireRequest(requestData) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats;

    return fetch(`${basePath}/api/v1/tire-request`, {
      body: JSON.stringify({ ...requestData, visitorId }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(({ data }) => {
        dispatch({
          type: types.TIRE_REQUEST_SENT,
          data,
        });
        return data;
      });
    });
  };
}

export function searchTiresByDimensions(width, profile, rim) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/tires/MO/${width}/${profile}/${rim}`).then(
      function (apiResult) {
        return apiResult.json().then((data) => {
          return dispatch({
            type: types.LOAD_MOTO_TIRES,
            motoTires: data,
            motoTiresQueryKey: getMotoTiresQueryKey(width, profile, rim),
          });
        });
      }
    );
  };
}

export function searchTirePairsByDimensions(front, rear) {
  return function (dispatch, getState) {
    const tirePairsQueryKey = getMotoTirePairsQueryKey(front, rear);
    const isLatest = () => {
      return getState().catalogReducer.tirePairsRequestedKey === tirePairsQueryKey;
    };

    dispatch({
      type: types.LOAD_MOTO_TIRE_PAIRS_PENDING,
      tirePairsRequestedKey: tirePairsQueryKey,
    });

    return fetch(
      `${basePath}/api/v1/tires/MO/pair/${front.width}/${front.profile}/${front.rim}/${rear.width}/${rear.profile}/${rear.rim}`
    )
      .then((apiResult) => apiResult.json())
      .then((data) => {
        if (!isLatest()) {
          return null;
        }

        return dispatch({
          type: types.LOAD_MOTO_TIRE_PAIRS,
          motoTirePairs: (data && data.pairs) || [],
          tirePairsQueryKey,
          settings: data && data.settings,
          years: data && data.years,
        });
      })
      .catch(() => {
        if (!isLatest()) {
          return null;
        }

        return dispatch({
          type: types.LOAD_MOTO_TIRE_PAIRS,
          motoTirePairs: [],
        });
      });
  };
}

export function validateTireAvailability(width, profile, rim) {
  return function (dispatch, getState) {
    dispatch({
      type: types.VALIDATE_TIRE_AVAILABILITY_PENDING,
    });

    fetch(`${basePath}/api/v1/tires/MO/${width}/${profile}/${rim}`)
      .then(function (apiResult) {
        return apiResult.json().then((data) => {
          const catalog = getState().catalogReducer;
          if (
            catalog.setSearchOpen ||
            String(catalog.selectedWidth) !== String(width) ||
            String(catalog.selectedProfile) !== String(profile) ||
            String(catalog.selectedRim) !== String(rim)
          ) {
            return;
          }

          const tireCount = countSizePageResults(data && data.result);

          dispatch({
            type: types.VALIDATE_TIRE_AVAILABILITY_SUCCESS,
            tireCount,
            hasAvailableTires: tireCount > 0,
          });
        });
      })
      .catch(function (error) {
        const catalog = getState().catalogReducer;
        if (
          catalog.setSearchOpen ||
          String(catalog.selectedWidth) !== String(width) ||
          String(catalog.selectedProfile) !== String(profile) ||
          String(catalog.selectedRim) !== String(rim)
        ) {
          return;
        }
        dispatch({
          type: types.VALIDATE_TIRE_AVAILABILITY_ERROR,
          error: error.message,
        });
      });
  };
}

export function resetTireValidation() {
  return {
    type: types.RESET_TIRE_VALIDATION,
  };
}

function isCurrentTirePair(catalog, front, rear) {
  return (
    catalog.setSearchOpen &&
    String(catalog.selectedWidth) === String(front.width) &&
    String(catalog.selectedProfile) === String(front.profile) &&
    String(catalog.selectedRim) === String(front.rim) &&
    String(catalog.rearSelectedWidth) === String(rear.width) &&
    String(catalog.rearSelectedProfile) === String(rear.profile) &&
    String(catalog.rearSelectedRim) === String(rear.rim)
  );
}

export function validateTirePairAvailability(front, rear) {
  return function (dispatch, getState) {
    dispatch({
      type: types.VALIDATE_TIRE_AVAILABILITY_PENDING,
    });

    fetch(
      `${basePath}/api/v1/tires/MO/pair/${front.width}/${front.profile}/${front.rim}/${rear.width}/${rear.profile}/${rear.rim}`
    )
      .then(function (apiResult) {
        return apiResult.json().then((data) => {
          if (!isCurrentTirePair(getState().catalogReducer, front, rear)) return;
          const pairs = (data && data.pairs) || [];
          const tireCount = pairs.length;
          dispatch({
            type: types.VALIDATE_TIRE_AVAILABILITY_SUCCESS,
            tireCount,
            hasAvailableTires: tireCount > 0,
          });
        });
      })
      .catch(function (error) {
        if (!isCurrentTirePair(getState().catalogReducer, front, rear)) return;
        dispatch({
          type: types.VALIDATE_TIRE_AVAILABILITY_ERROR,
          error: error.message,
        });
      });
  };
}

export function searchTiresByBrand(brand) {
  return (dispatch) => {
    return fetch(`${basePath}/api/v1/bybrand/MO/tires/${brand}`).then(function (
      apiResult
    ) {
      return apiResult.json().then((data) => {
        return dispatch({
          type: types.LOAD_MOTO_TIRES,
          motoTires: data,
          motoTiresQueryKey: `brand:${brand}`,
        });
      });
    });
  };
}

export function searchMotoTiresByCategory(categoryId) {
  return (dispatch) => {
    return fetch(`${basePath}/api/v1/category/${categoryId}/items`).then(
      (apiResult) => {
        return apiResult.json().then((data) => {
          return dispatch({
            type: types.LOAD_MOTO_TIRES_BY_CAT,
            motoTires: data.result,
            nextShipment: data.settings.nextShipmentDisplayTime,
            euContainerMode: data.settings.euContainerMode || null,
            category: data.category,
            motoTiresQueryKey: `category:${categoryId}`,
          });
        });
      }
    );
  };
}

export function changeCityIndexPage(city) {
  return {
    type: types.PICK_CITY_SHOPS_PAGE,
    city,
  };
}

export function setPaymentPageStage(stageName) {
  return {
    type: types.PAYMENT_PAGE_STAGE,
    stageName,
  };
}

export function getShopCities() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/cities`).then(function (apiResult) {
      return apiResult.json().then(function (cities) {
        return dispatch({
          type: types.LOAD_CITIES_FOR_SHOPS_PAGE,
          cities,
        });
      });
    });
  };
}

export function getShopsByCityIndexPage(city) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/cities/${city}/shops`).then(function (apiResult) {
      return apiResult.json().then(function (shops) {
        return dispatch({
          type: types.LOAD_SHOPS_INDEX_PAGE,
          shops,
        });
      });
    });
  };
}

export function getProductByEAN(ean) {
  return (dispatch) => {
    return fetch(`${basePath}/api/v1/tires/MO/${ean}`).then((apiResult) => {
      return apiResult.json().then((data) => {
        const products = data.result;
        if (data.localStockBlock?.blocked) {
          dispatch({
            type: types.LOAD_PRODUCT,
            productPending: false,
            product: null,
            productNotFound: false,
            localStockBlock: data.localStockBlock,
          });
          return;
        }
        if (products.length === 0) {
          dispatch({
            type: types.LOAD_PRODUCT,
            productPending: false,
            product: null,
            productNotFound: true,
            localStockBlock: null,
          });
        }

        if (products && products[0] && products[0].ean === ean) {
          console.log("dispatching that instead!");
          dispatch({
            type: types.LOAD_PRODUCT,
            product: products[0],
            productNotFound: false,
            nextShipment: data.settings.nextShipmentDisplayTime,
            currentShipment: data.settings.currentShipmentDisplayTime,
            nextShipmentDeadline: data.settings.nextShipmentOrderDeadline,
            euContainerMode: data.settings.euContainerMode || null,
            tireYears: data.years.tireYears,
            productPending: false,
          });
        }
      });
    });
  };
}

export function loadTireProfilesByWidth(
  width,
  axle = "front",
  { autoSelect = true } = {}
) {
  return (dispatch) => {
    return fetch(`${basePath}/api/v1/sizes/profiles/for/MO/${width}`)
      .then((apiResult) => {
        return apiResult.json().then((profiles) => {
          if (axle === "rear") {
            dispatch({
              type: types.MOTO_REAR_TIRE_DIMS_PROFILES,
              profiles,
            });
            return profiles;
          }

          dispatch({
            type: types.MOTO_TIRE_DIMS_PROFILES,
            profiles,
          });

          if (autoSelect && profiles.length === 2) {
            dispatch({
              type: types.MOTO_SELECT_PROFILE_DIM,
              selectedProfile: profiles[1],
            });
            dispatch(loadTireRimsByWidthAndProfile(width, profiles[1]));
          }

          return profiles;
        });
      })
      .catch((err) => err);
  };
}

export function getShopByName(name) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/shop/${name}`).then(function (apiResult) {
      return apiResult.json().then(function (shop) {
        return dispatch({
          type: types.LOAD_SHOP_BY_NAME,
          shop,
        });
      });
    });
  };
}

export function loadTireRimsByWidthAndProfile(
  width,
  profile,
  axle = "front",
  { autoSelect = true } = {}
) {
  return (dispatch) => {
    return fetch(`${basePath}/api/v1/sizes/for/MO/${width}/${profile}`)
      .then((apiResult) => {
        return apiResult.json().then((rims) => {
          if (axle === "rear") {
            dispatch({
              type: types.MOTO_REAR_TIRE_DIMS_RIMS,
              rims,
            });
            return rims;
          }

          dispatch({
            type: types.MOTO_TIRE_DIMS_RIMS,
            rims,
          });

          if (autoSelect && rims.length === 1) {
            dispatch({
              type: types.MOTO_SELECT_RIM_DIM,
              selectedRim: rims[0],
            });
          }

          return rims;
        });
      })
      .catch((err) => err);
  };
}

export function getInstallCities() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/checkout/installation/cities`).then(function (
      apiResult
    ) {
      return apiResult.json().then(function (cities) {
        return dispatch({
          type: types.LOAD_INSTALL_CITIES,
          cities,
        });
      });
    });
  };
}

export function getShopsByCity(cityCode) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/checkout/shops/in/${cityCode}`).then(function (
      apiResult
    ) {
      return apiResult.json().then(function (shops) {
        return dispatch({
          type: types.LOAD_SHOPS,
          shops,
        });
      });
    });
  };
}

export function pickInstallDate(date) {
  return {
    type: types.PICK_INSTALL_DATE,
    date,
  };
}

export function getOpenDatesForShop(shopCodename) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/checkout/install/dates/${shopCodename}`).then(
      function (apiResult) {
        return apiResult.json().then(function (dates) {
          return dispatch({
            type: types.LOAD_OPENDATES_FOR_INSTALLATION,
            dates,
          });
        });
      }
    );
  };
}

export function getInstallSlotsForDate(date, shopCodename) {
  return function (dispatch) {
    fetch(
      `${basePath}/api/v1/checkout/install/slots/${shopCodename}/${date}`
    ).then(function (apiResult) {
      return apiResult.json().then(function (slots) {
        return dispatch({
          type: types.LOAD_INSTALL_SLOTS,
          slots,
        });
      });
    });
  };
}

function getProductByEANInternal(ean) {
  return fetch(`${basePath}/api/v1/tires/MO/${ean}`).then((result) => {
    return result.json();
  });
}

export function getCartProducts(cart) {
  let nextShipment = false;
  let currentShipmentDisplayTime = "";
  let nextShipmentOrderDeadline = "";
  let euContainerMode = null;

  return (dispatch) => {
    return Promise.all(
      cart.items.map((item) =>
        getProductByEANInternal(item.ean).then((data) => {
          nextShipment = data.settings.nextShipmentDisplayTime;
          currentShipmentDisplayTime = data.settings.currentShipmentDisplayTime;
          nextShipmentOrderDeadline = data.settings.nextShipmentOrderDeadline;
          euContainerMode = data.settings.euContainerMode || euContainerMode;
          if (data.localStockBlock?.blocked) {
            return { localStockBlock: data.localStockBlock };
          }
          return data.result[0];
        })
      )
    ).then((results) => {
      const localStockBlocks = results
        .filter((item) => item?.localStockBlock?.blocked)
        .map((item) => item.localStockBlock);
      return dispatch({
        type: types.CART_PRODUCTS_DATA,
        results: results.filter((item) => item && !item.localStockBlock),
        localStockBlocks,
        nextShipment,
        currentShipmentDisplayTime,
        nextShipmentOrderDeadline,
        euContainerMode,
      });
    });
  };
}

export function pickInstallSlot(slot) {
  return {
    type: types.PICK_INSTALL_SLOT,
    slot,
  };
}

export function clearPickShop() {
  return {
    type: types.CLEAR_PICK_SHOP,
  };
}

export function pickShopById(shopId) {
  return {
    type: types.CHANGE_INSTALL_SHOP,
    shopId,
  };
}

export function changeProductQuantity(ean, quantity) {
  return {
    type: types.CHANGE_PRODUCT_QUANTITY_IN_CART,
    quantity,
    ean,
  };
}

export function changeInstallCity(city) {
  return {
    type: types.CHANGE_INSTALL_CITY,
    city,
  };
}

export function removeItemFromCart(ean) {
  return {
    type: types.REMOVE_PRODUCT_FROM_CART,
    ean,
  };
}

export function changeSip(sip) {
  return {
    type: types.CHANGE_SIP,
    sip,
  };
}

export function toggleSnackbar(toggle, snack) {
  return {
    type: types.TOGGLE_SNACKBAR,
    snack,
    toggle,
  };
}

export function selectWidth(selectedWidth) {
  return {
    type: types.MOTO_SELECT_WIDTH_DIM,
    selectedWidth,
  };
}

export function restoreCart() {
  return {
    type: types.RESTORE_CART,
  };
}

export function onFormFieldChangeInShippingStep(name, value) {
  return {
    type: types.FORM_FIELD_CHANGE_SHIPPING,
    name,
    value,
  };
}

export function onFormFieldChangePersonalStep(name, value) {
  let finalValue = value;
  if (name === "emailaddress") {
    finalValue = value.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  return {
    type: types.FORM_FIELD_CHANGE_PERSONAL,
    name,
    value: finalValue,
  };
}

export function onFormFieldChangeInPaymentStep(name, value) {
  return {
    type: types.FORM_FIELD_CHANGE_PAYMENT,
    name,
    value,
  };
}

export function setLoaderIsLoading(value) {
  return {
    type: types.LOADER_IS_LOADING,
    value,
  };
}

//New function for additional notes
export function onTextAreaChangeNotes(name, value) {
  return {
    type: types.CHANGE_ADDITIONAL_NOTES,
    name,
    value,
  };
}

export function changePaymentMethod(method) {
  return {
    type: types.CHANGE_PAYMENT_METHOD,
    method,
  };
}

export function updateOrderProps(id, orderProps) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/order/${id}`, {
      body: JSON.stringify(orderProps),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
        ...utils.getAdminAuthHeaders(),
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(function (result) {
        return dispatch({
          type: types.ADMIN_ORDER_UPDATED,
          result,
        });
      });
    });
  };
}

export function resendPurchaseEmails(orderId) {
  return function (dispatch) {
    fetch(
      `${basePath}/api/v1/order/${orderId}/resend-purchase-emails`,
      {
        body: JSON.stringify({}),
        cache: "no-cache",
        headers: {
          "content-type": "application/json",
          ...utils.getAdminAuthHeaders(),
        },
        method: "POST",
        mode: "cors",
        redirect: "follow",
        referrer: "no-referrer",
      }
    ).then(function (apiResult) {
      return apiResult.json().then(function (result) {
        return dispatch({
          type: types.ADMIN_ORDER_UPDATED,
          result,
        });
      });
    });
  };
}

export function finalizeOrder({
  personalId,
  cardMask,
  txId,
  authNumber,
  responseMAC,
  uniqueID,
  traceId,
}) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats;

    fetch(`${basePath}/api/v1/finalize/checkout`, {
      body: JSON.stringify({
        personalId,
        cardMask,
        txId,
        authNumber,
        responseMAC,
        uniqueID,
        visitorId,
        traceId,
      }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
        ...(traceId ? { "x-payment-trace-id": traceId } : {}),
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(function (result) {
        if (result.ok) {
          dispatch({
            type: types.PAYMENT_PAGE_STAGE,
            stageName: "/paymentSuccess",
            orderId: result.orderId,
          });
        } else {
          dispatch({
            type: types.PAYMENT_PAGE_STAGE,
            stageName: "/paymentFailed",
          });
        }
      });
    });
  };
}

export function submitOrder(cart, checkout) {
  const shop = checkout.shops.find((s) => s.id === checkout.selectedShop);
  const stats = cStorage.getObject("stats");
  const { visitorId } = stats;

  const cleanCheckout = objectAssign({}, checkout, {
    shop,
    visitorId,
  });

  delete cleanCheckout.cities;
  delete cleanCheckout.shops;
  delete cleanCheckout.dates;
  delete cleanCheckout.slots;

  return function (dispatch) {
    fetch(`${basePath}/api/v1/checkout`, {
      body: JSON.stringify({
        cart,
        checkout: cleanCheckout,
      }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(function (result) {
        if (result.success) {
          if ("redirectUrl" in result) {
            window.location.href = result.redirectUrl;
          } else {
            dispatch({
              type: types.COMPLETE_ORDER,
              result,
            });
          }
        } else {
          dispatch({
            type: types.CHECKOUT_ORDER_ERROR,
            result,
          });
        }
      });
    });
  };
}

export function updateFilters(filters) {
  return {
    type: types.UPDATE_FILTERS,
    filters,
  };
}

export function addProductsToCart(items) {
  return (dispatch) => {
    const list = items || [];

    return Promise.all(
      list.map((item) => {
        return fetch(
          `${basePath}/api/v1/local-stock-block/${encodeURIComponent(item.ean)}`
        )
          .then((response) => response.json())
          .then((block) => ({ item, block }))
          .catch(() => ({ item, block: null }));
      })
    ).then((results) => {
      const blocked = results.find((result) => result.block?.blocked);

      if (blocked) {
        dispatch(
          toggleSnackbar(true, {
            message: blocked.block.message,
            type: "localStockInstead",
            replacement: blocked.block.replacement || null,
          })
        );
        return false;
      }

      results.forEach((result) => {
        dispatch({
          type: types.ADD_PRODUCT_TO_CART,
          ean: result.item.ean,
          isSet: result.item.isSet,
          isAtvSet: result.item.isAtvSet,
        });
      });

      return true;
    });
  };
}

export function addProductToCart(ean, isSet = false, isAtvSet = false) {
  return addProductsToCart([{ ean, isSet, isAtvSet }]);
}

export function selectProfile(selectedProfile) {
  return {
    type: types.MOTO_SELECT_PROFILE_DIM,
    selectedProfile,
  };
}

export function resetDimensionsMoto() {
  return {
    type: types.MOTO_RESET_DIMS,
  };
}

export function selectRim(selectedRim) {
  return {
    type: types.MOTO_SELECT_RIM_DIM,
    selectedRim,
  };
}

function matchingOption(list, value) {
  if (value === undefined || value === null || value === "") return "";
  const match = (list || []).find((item) => String(item) === String(value));
  return match !== undefined ? match : String(value);
}

function listWithValue(list, value) {
  const options = Array.isArray(list) ? list.slice() : [];
  if (value === undefined || value === null || value === "") return options;
  if (options.some((item) => String(item) === String(value))) return options;
  return options.concat(String(value));
}

export function selectRearWidth(rearSelectedWidth) {
  return {
    type: types.MOTO_SELECT_REAR_WIDTH_DIM,
    rearSelectedWidth,
  };
}

export function selectRearProfile(rearSelectedProfile) {
  return {
    type: types.MOTO_SELECT_REAR_PROFILE_DIM,
    rearSelectedProfile,
  };
}

export function selectRearRim(rearSelectedRim) {
  return {
    type: types.MOTO_SELECT_REAR_RIM_DIM,
    rearSelectedRim,
  };
}

export function resetRearDimensions() {
  return {
    type: types.MOTO_RESET_REAR_DIMS,
  };
}

export function setFrontTouched(frontTouched) {
  return {
    type: types.SET_FRONT_TOUCHED,
    frontTouched,
  };
}

export function setRearTouched(rearTouched) {
  return {
    type: types.SET_REAR_TOUCHED,
    rearTouched,
  };
}

export function setSearchOpen(open) {
  return {
    type: types.SET_SEARCH_OPEN,
    setSearchOpen: open,
  };
}

function resetFrontDimensions() {
  return (dispatch) => {
    dispatch(resetDimensionsMoto());
    dispatch(selectWidth(""));
  };
}

const AXLES = {
  front: {
    width: "selectedWidth",
    profile: "selectedProfile",
    rim: "selectedRim",
    profiles: "profiles",
    rims: "rims",
    touched: "frontTouched",
    profilesType: types.MOTO_TIRE_DIMS_PROFILES,
    rimsType: types.MOTO_TIRE_DIMS_RIMS,
    selectWidth,
    selectProfile,
    selectRim,
    reset: resetFrontDimensions,
  },
  rear: {
    width: "rearSelectedWidth",
    profile: "rearSelectedProfile",
    rim: "rearSelectedRim",
    profiles: "rearProfiles",
    rims: "rearRims",
    touched: "rearTouched",
    profilesType: types.MOTO_REAR_TIRE_DIMS_PROFILES,
    rimsType: types.MOTO_REAR_TIRE_DIMS_RIMS,
    selectWidth: selectRearWidth,
    selectProfile: selectRearProfile,
    selectRim: selectRearRim,
    reset: resetRearDimensions,
  },
};

const OPPOSITE_AXLE = { front: "rear", rear: "front" };

function getAxleSize(catalog, axle) {
  const config = AXLES[axle];
  return {
    width: catalog[config.width],
    profile: catalog[config.profile],
    rim: catalog[config.rim],
  };
}

function isSameSize(left, right) {
  return ["width", "profile", "rim"].every(
    (field) => String(left[field] || "") === String(right[field] || "")
  );
}

function moveAxleSize(fromAxle, toAxle) {
  return (dispatch, getState) => {
    const catalog = getState().catalogReducer;
    const from = AXLES[fromAxle];
    const to = AXLES[toAxle];

    dispatch({ type: to.profilesType, profiles: catalog[from.profiles] || [] });
    dispatch({ type: to.rimsType, rims: catalog[from.rims] || [] });
    dispatch(to.selectWidth(catalog[from.width] || ""));
    dispatch(to.selectProfile(catalog[from.profile] || ""));
    dispatch(to.selectRim(catalog[from.rim] || ""));
    dispatch(from.reset());
  };
}

function prefillAxleSize(axle, target, isStillValid) {
  const config = AXLES[axle];

  return (dispatch, getState) => {
    const stillValid = () => isStillValid(getState().catalogReducer);
    const widthValue = matchingOption(getState().catalogReducer.widths, target.width);

    dispatch(config.selectProfile(""));
    dispatch(config.selectRim(""));
    dispatch(config.selectWidth(widthValue));

    return dispatch(
      loadTireProfilesByWidth(widthValue, axle, { autoSelect: false })
    ).then((profiles) => {
      if (!stillValid()) return null;

      const profileOptions = listWithValue(profiles, target.profile);
      const profileValue = matchingOption(profileOptions, target.profile);
      dispatch({ type: config.profilesType, profiles: profileOptions });
      dispatch(config.selectProfile(profileValue));

      return dispatch(
        loadTireRimsByWidthAndProfile(widthValue, profileValue, axle, {
          autoSelect: false,
        })
      ).then((rims) => {
        if (!stillValid()) return;

        const rimOptions = listWithValue(rims, target.rim);
        dispatch({ type: config.rimsType, rims: rimOptions });
        dispatch(config.selectRim(matchingOption(rimOptions, target.rim)));
      });
    });
  };
}

export function loadSizeSuggestions(sourceAxle, size) {
  const targetAxle = OPPOSITE_AXLE[sourceAxle];

  return (dispatch, getState) => {
    const isStillValid = (catalog) =>
      catalog.setSearchOpen &&
      !catalog[AXLES[targetAxle].touched] &&
      isSameSize(getAxleSize(catalog, sourceAxle), size);

    return fetch(
      `${basePath}/api/v1/sizes/pairings/${sourceAxle}/${size.width}/${size.profile}/${size.rim}`
    )
      .then((apiResult) => apiResult.json())
      .then((data) => {
        const top = data && data.result && data.result[0];
        const catalog = getState().catalogReducer;
        if (!top || !isStillValid(catalog)) return null;
        if (isSameSize(getAxleSize(catalog, targetAxle), top)) return null;

        return dispatch(prefillAxleSize(targetAxle, top, isStillValid));
      })
      .catch((err) => err);
  };
}

let popularTireSetSelection = 0;

export function applyPopularTireSet(tireSet) {
  return (dispatch) => {
    const selection = ++popularTireSetSelection;
    const isStillValid = (catalog) =>
      catalog.setSearchOpen && selection === popularTireSetSelection;

    fetch(`${basePath}/api/v1/sizes/popular-sets/click`, {
      method: "POST",
      body: JSON.stringify({ key: tireSet.key }),
      headers: { "Content-Type": "application/json" },
    }).catch((err) => err);

    dispatch(setFrontTouched(true));
    dispatch(setRearTouched(true));
    dispatch(resetTireValidation());

    return Promise.all([
      dispatch(prefillAxleSize("front", tireSet.front, isStillValid)),
      dispatch(prefillAxleSize("rear", tireSet.rear, isStillValid)),
    ]).catch((err) => err);
  };
}

export function openSetSearch() {
  return (dispatch, getState) => {
    const hasEnteredSize = Boolean(getState().catalogReducer.selectedWidth);

    dispatch(resetRearDimensions());
    if (hasEnteredSize) {
      dispatch(moveAxleSize("front", "rear"));
    }
    dispatch(setFrontTouched(false));
    dispatch(setRearTouched(hasEnteredSize));
    dispatch(resetTireValidation());
    dispatch(setSearchOpen(true));
  };
}

export function closeSetSearch() {
  return (dispatch, getState) => {
    const catalog = getState().catalogReducer;
    const keepRear =
      Boolean(catalog.rearSelectedWidth) &&
      (catalog.rearTouched || !catalog.selectedWidth);

    if (keepRear) {
      dispatch(moveAxleSize("rear", "front"));
    } else {
      dispatch(resetRearDimensions());
    }
    dispatch(setFrontTouched(false));
    dispatch(setRearTouched(false));
    dispatch(resetTireValidation());
    // HomePage.componentDidUpdate re-counts the single size when set mode closes.
    dispatch(setSearchOpen(false));
  };
}

export function updateWizardUserAnswer(value) {
  return {
    type: types.WIZARD_USER_ANSWER,
    payload: value,
  };
}

export function setWizardLoadingState() {
  return {
    type: types.SET_WIZARD_LOADING,
  };
}

export function resetWizardAnswers() {
  return {
    type: types.RESET_WIZARD,
  };
}

export function setWizardStep(step) {
  return {
    type: types.SET_WIZARD_STEP,
    step,
  };
}

export function sendAnswersToAI(answers) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats;

    fetch(`${basePath}/api/v1/wizard/recommend-tiers`, {
      body: JSON.stringify({ ...answers, visitorId }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then((apiResult) => {
      return apiResult.json().then((result) => {
        setTimeout(() => {
          if (result.ok) {
            dispatch({
              type: types.SUBMIT_WIZARD_ANSWERS,
              payload: result,
            });
          } else {
            dispatch({
              type: types.SUBMIT_WIZARD_ANSWERS,
              payload: result,
            });
          }
        }, 6000);
      });
    });
  };
}

export function applyCoupon(code, cart) {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/validate-coupon`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, cart }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.valid) {
          dispatch({
            type: types.APPLY_COUPON,
            code,
            discount: result.discount,
          });
        } else {
          dispatch({
            type: types.APPLY_COUPON_ERROR,
            error: "קוד קופון לא תקין",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: types.APPLY_COUPON_ERROR, error: error.message });
      });
  };
}

export function getAllMotorcycleBrands() {
  return function (dispatch) {
    fetch(`${basePath}/api/v1/motorcycle/brands`).then(function (apiResult) {
      return apiResult.json().then(function (data) {
        return dispatch({
          type: types.TAKE_ALL_MOTO_BRANDS_AVAILABLE,
          brands: data.brands,
        });
      });
    });
  };
}

export function getMotorcyclesByUserModelAndYear(brand, year) {
  return function (dispatch) {
    return fetch(`${basePath}/api/v1/motorcycle/models`, {
      body: JSON.stringify({ brand, year }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then(function (apiResult) {
      return apiResult.json().then(function (data) {
        dispatch({
          type: types.TAKE_MOTO_LIST_FOR_GPT,
          motorcycles: data,
        });
        return data;
      });
    });
  };
}

export function setUserModelLoading(isLoading) {
  return {
    type: types.SET_USER_MODEL_LOADING,
    isLoading,
  };
}

export function showUserModelSuccess() {
  return {
    type: types.SHOW_USER_MODEL_SUCCESS,
  };
}

export function hideUserModelSuccess() {
  return {
    type: types.SHOW_USER_MODEL_SUCCESS,
    hide: true,
  };
}

export function setUserHasSubmittedModel(hasSubmitted) {
  return {
    type: types.SET_USER_HAS_SUBMITTED_MODEL,
    hasSubmitted,
  };
}

export function sendUserModelToAdd(bikeModel) {
  return function (dispatch) {
    // Set loading state
    dispatch(setUserModelLoading(true));
    return new Promise((resolve) => {
      setTimeout(() => {
        fetch(`${basePath}/api/v1/motorcycle/model-to-add`, {
          body: JSON.stringify({ bikeModel }),
          cache: "no-cache",
          headers: {
            "content-type": "application/json",
          },
          method: "POST",
          mode: "cors",
          redirect: "follow",
          referrer: "no-referrer",
        })
          .then(function (apiResult) {
            return apiResult.json().then(function (data) {
              // Stop loading
              dispatch(setUserModelLoading(false));

              if (data.ok) {
                dispatch(setUserHasSubmittedModel(true));
                dispatch(showUserModelSuccess());
              }

              dispatch({
                type: types.SUBMIT_USER_BIKE_MODEL_TO_ADD,
                payload: data,
              });

              resolve(data);
            });
          })
          .catch((error) => {
            // Stop loading on error
            dispatch(setUserModelLoading(false));
            throw error;
          });
      }, 5000);
    });
  };
}

export function trackTireClick(tireInfo, wizardResponses, usageId) {
  return function (dispatch) {
    const stats = cStorage.getObject("stats");
    const { visitorId } = stats;

    if (!visitorId) {
      console.warn("No visitor ID found, cannot track tire click");
      return;
    }

    fetch(`${basePath}/api/v1/wizard/track-tire-click`, {
      body: JSON.stringify({
        visitorId,
        tireInfo,
        wizardResponses,
        usageId,
      }),
      cache: "no-cache",
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    })
      .then((apiResult) => {
        return apiResult.json().then((result) => {
          if (result.ok) {
            console.log("Tire click tracked successfully");
          } else {
            console.error("Failed to track tire click:", result.error);
          }
        });
      })
      .catch((error) => {
        console.error("Error tracking tire click:", error);
      });
  };
}

// Removed storeWizardResponses action - now handled in sendAnswersToAI
// Draft Orders Actions
export const getDraftOrders = () => {
  return (dispatch) => {
    dispatch({ type: "GET_DRAFT_ORDERS_PENDING" });

    return fetch(
      `${basePath}/api/v1/draft-orders?limit=50&sortBy=createdAt&sortOrder=-1`,
      { headers: utils.getAdminAuthHeaders() }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          dispatch({
            type: "GET_DRAFT_ORDERS_SUCCESS",
            payload: data.orders,
          });
        } else {
          dispatch({
            type: "GET_DRAFT_ORDERS_ERROR",
            payload: data.error || "Failed to fetch draft orders",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "GET_DRAFT_ORDERS_ERROR",
          payload: error.message,
        });
      });
  };
};

export const createDraftOrder = (createdBy = "admin-user") => {
  return (dispatch) => {
    dispatch({ type: "CREATE_DRAFT_ORDER_PENDING" });

    return fetch(`${basePath}/api/v1/draft-orders/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...utils.getAdminAuthHeaders(),
      },
      body: JSON.stringify({ createdBy }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          dispatch({
            type: "CREATE_DRAFT_ORDER_SUCCESS",
            payload: {
              draftOrderId: data.draftOrderId,
              status: data.status,
              message: data.message,
            },
          });
          return data;
        } else {
          dispatch({
            type: "CREATE_DRAFT_ORDER_ERROR",
            payload: data.error || "Failed to create draft order",
          });
          throw new Error(data.error || "Failed to create draft order");
        }
      })
      .catch((error) => {
        dispatch({
          type: "CREATE_DRAFT_ORDER_ERROR",
          payload: error.message,
        });
        throw error;
      });
  };
};

export const getDraftOrderDetails = (orderId) => {
  return (dispatch) => {
    dispatch({ type: "GET_DRAFT_ORDER_DETAILS_PENDING" });

    return fetch(`${basePath}/api/v1/draft-orders/${orderId}`, {
      headers: utils.getAdminAuthHeaders(),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          dispatch({
            type: "GET_DRAFT_ORDER_DETAILS_SUCCESS",
            payload: data.order,
          });
          return data.order;
        } else {
          dispatch({
            type: "GET_DRAFT_ORDER_DETAILS_ERROR",
            payload: data.error || "Failed to fetch draft order details",
          });
          throw new Error(data.error || "Failed to fetch draft order details");
        }
      })
      .catch((error) => {
        dispatch({
          type: "GET_DRAFT_ORDER_DETAILS_ERROR",
          payload: error.message,
        });
        throw error;
      });
  };
};
